import React from "react";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes, useAppSelector } from "src/common";
import { Icon, ToolbarButton, ToolbarWrapper, ToolbarFilter } from "src/components";
import { RootState } from "src/store/configureStore";

type AllProps = {
  is_loading: boolean;
  address_list_length: number;
  filtered_list_length: number;
  handleAction: ActionHandlerFunction;
  filter_param?: string;
}

// Description: Renders the toolbar in the email gateway page.
// contains a filter, an add button, a delete button, and a refresh button.
function ToolbarComponent(props: AllProps) {
  const { is_loading, address_list_length, filtered_list_length, filter_param, handleAction } = props;
  const selected = useAppSelector((state: RootState) => state.admin.selected);

  const count_label = address_list_length > 0
    ? `${filtered_list_length < address_list_length ? `${filtered_list_length} of ` : ""}${address_list_length} ${address_list_length > 1 ? "Entries" : "Entry"}`
    : "";

  return <ToolbarWrapper
    leftContent={<ToolbarFilter
      disabled={address_list_length === 0}
      filter_param={filter_param ?? ""}
      onChange={(value) => handleAction({ actionType: AdminUIActionTypes.SearchParam, params: value })}
      onClick={() => handleAction({ actionType: AdminUIActionTypes.SearchParam })} />}
    paginationInfo={<span className="pagination_info">{count_label}</span>}
    refreshAction={() => handleAction({ actionType: AdminUIActionTypes.GetRefreshRequest })}
    refreshTooltipContent="Refresh Trusted Addresses"
    isLoading={is_loading}
  >
    <ToolbarButton
      onClick={() => handleAction({ actionType: AdminUIActionTypes.ShowModal })}
      ariaLabel="Create Trusted Address"
      tooltipContent="Create Trusted Address">
      <Icon className="ficon-plus" />
    </ToolbarButton>
    <ToolbarButton
      disabled={selected.length === 0}
      onClick={() => handleAction({ actionType: AdminUIActionTypes.Delete })}
      ariaLabel="Delete Selected"
      tooltipContent="Delete Selected">
      <Icon className="ficon-trash-2" />
    </ToolbarButton>
  </ToolbarWrapper>;
}

export default React.memo(ToolbarComponent);
